var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"post-header__user-icon",attrs:{"src":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }